// 项目配置

export default {
  title: "水质监管平台",
  appId: "58",
  loginBackgroundImage:
    "https://webfron.czczh.net/static/bg_images/login_bg1.png"
};
